// Utility function to get correct image URL for any environment
// SOLUCIÓN DEFINITIVA para URLs de imágenes

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const getImageUrl = (url) => {
  // Si no hay URL, retornar null
  if (!url) return null;
  
  // Si ya es URL completa (http o https), retornar tal cual
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  
  // Si es /api/uploads/, agregar backend URL al inicio
  if (url.startsWith("/api/uploads/")) {
    return `${BACKEND_URL}${url}`;
  }
  
  // Si es /uploads/ (formato antiguo), convertir a /api/uploads/
  if (url.startsWith("/uploads/")) {
    return `${BACKEND_URL}/api${url}`;
  }
  
  // Si empieza con /, agregar backend URL
  if (url.startsWith("/")) {
    return `${BACKEND_URL}${url}`;
  }
  
  // Cualquier otra cosa, asumir que es relativa
  return `${BACKEND_URL}/${url}`;
};

// Función para obtener URL de placeholder
export const getPlaceholderImage = () => {
  return "https://via.placeholder.com/800x600/1a1a2e/eee?text=Sin+Imagen";
};

export default getImageUrl;
